import { Shape, type Vector2 } from 'three';

import type { CutoutInfo } from '../types';

/**
 * Every closed outline one opening cuts: the slots of a vent's 2D artwork when it has them, the
 * single loop of a plain cutout otherwise. `points` only ever holds `shapes[0]`, so anything that
 * reads it alone covers the first slot of a vent and none of the rest.
 */
export const cutoutProfileShapes = (cutout: CutoutInfo): Array<Shape> => {
	const profiles: Array<Array<Vector2>> = cutout.shapes?.length
		? cutout.shapes
		: (cutout.points ? [cutout.points] : []);

	return profiles
		.filter((loop) => loop.length >= 3)
		.map((loop) => {
			const shape = new Shape();
			shape.moveTo(loop[0].x, loop[0].y);
			for (let i = 1; i < loop.length; i++) {
				shape.lineTo(loop[i].x, loop[i].y);
			}
			// Close the shape
			shape.lineTo(loop[0].x, loop[0].y);
			return shape;
		});
};
